<script lang="ts">
    import { onMount } from "svelte";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { networkStore } from "../../../../store/networks";
    import { user } from "../../../../store/stores";
    import PlaysCounter from "./Components/PlaysCounter.svelte";
    import PlaysTimeline from "./Components/PlaysTimeline.svelte";
    import { DatePicker, DatePickerInput } from "carbon-components-svelte";
    import { statsStore } from "../../../../store/stats";
    import dayjs, { Dayjs } from "dayjs";
    import weekday from "dayjs/plugin/weekday";
    import de from "dayjs/locale/de";
    import type {
        IAggregationDataResponse,
        IAggregationResponseItem,
        IOrganisationTimeRangeStats,
        IPopObject,
        ITimeRangeStats,
        rangeObject,
    } from "../../../../Types/Stats";
    import EventBus from "../../../../GlobalHelper/VertxBridge";
    import { eventbusUrl } from "../../../../settings/settings";
    import TimeSelectDropdown from "./Components/TimeSelectDropdown.svelte";
    import { reduceTo4H, reduceToDay } from "../../../../GlobalHelper/Util";

    let date = new Date();
    let popBuckets;
    let graphLabels;
    let loading = true;
    dayjs.extend(weekday).locale(de);

    $: popBuckets = [
        {
            label: "Impressions",
            data: $statsStore.organisationStats.timeRangeBuckets.map(
                (bucket) => bucket.impressions
            ),
            backgroundColor: ["rgba(54, 162, 235, 0.2)"],
            borderColor: ["rgba(54, 162, 235, 1)"],
            borderWidth: 1,
        },
    ];

    let range = {
        text: "Heute",
        start: dayjs()
            .set("ms", 0)
            .set("s", 0)
            .set("minute", 0)
            .set("hour", 0)
            .day(1),
        // .set("hour", 0),
        end: dayjs().add(1, "h"),
    };
    let defaultPeriodLengthInSec = 3600;

    const fillBucketsWithDataResponse = (
        data: IAggregationDataResponse,
        selectedRange: rangeObject,
        initialBuckets?: ITimeRangeStats[]
    ) => {
        const aggregatedOrganisationStats = {
            playouts: 0,
            impressions: 0,
            turnover: 0,
        };
        let newArray = [];
        if (selectedRange.end.diff(selectedRange.start, "day") > 7) {
            newArray = data.body.results
                .filter(
                    (result) => result.id.videoId !== "EXoQH3prqQjv6SmzSuCEox"
                )
                .reduce(reduceToDay, []);
        } else if (selectedRange.end.diff(selectedRange.start, "hour") > 24) {
            newArray = data.body.results
                .filter(
                    (result) => result.id.videoId !== "EXoQH3prqQjv6SmzSuCEox"
                )
                .reduce(reduceTo4H, []);
        } else {
            newArray = data.body.results.filter(
                (result) => result.id.videoId !== "EXoQH3prqQjv6SmzSuCEox"
            );
        }

        newArray.map((aggregate, index, array): IOrganisationTimeRangeStats => {
            aggregatedOrganisationStats.impressions += aggregate.impressions;
            aggregatedOrganisationStats.playouts += aggregate.count;
            aggregatedOrganisationStats.turnover +=
                (aggregate.impressions / 1000) * 7.5;
            console.log(aggregate.timestamp);
            return {
                start: aggregate.id.timestamp,
                end:
                    index !== array.length - 1
                        ? array[index + 1].id.timestamp
                        : null,
                playouts: aggregate.count,
                impressions: aggregate.impressions,
                turnover: (aggregate.impressions / 1000) * 7.5,
                potentialImpressions: 0,
                potentialPlayouts: 0,
                potentialTurnover: 0,
                id: null,
            };
        });
        statsStore.update((statsStore) => {
            return {
                ...statsStore,
                organisationStats: {
                    ...statsStore.organisationStats,
                    ...aggregatedOrganisationStats,
                    timeRangeBuckets: newArray,
                },
            };
        });
    };

    const createLabels = (selectedRange: rangeObject): void => {
        console.log($statsStore.organisationStats);
        const array: string[] =
            $statsStore.organisationStats.timeRangeBuckets.map((bucket) =>
                dayjs(bucket.id.timestamp).format(
                    selectedRange.end.diff(selectedRange.start, "day") > 7
                        ? "DD.MM."
                        : "ddd HH:mm"
                )
            );
        graphLabels = array;
    };

    const userInteraction = async () => {
        await $user.updateToken().then(async () => {});
    };

    const initEventBus = () => {
        statsStore.update((statsStore) => {
            return {
                ...statsStore,
                eventBus: new EventBus(eventbusUrl),
            };
        });
    };

    onMount(() => {
        userInteraction();
        initEventBus();

        // const worker = new Worker("/worker.js");

        $statsStore.eventBus.initializeConnection().then(() => {
            loading = true;
            const start = range.start;
            const end = range.end;
            $statsStore.eventBus.send(
                "channel://aggregates/groupByOrgIdAndVideoId",
                {
                    orgId: "4cd3f13b-604f-4ba8-baea-3c165d6b5bd3",
                    from: range.start.unix(),
                    to: range.end.unix(),
                },
                function (error, message) {
                    loading = false;
                    if (error) return;
                    fillBucketsWithDataResponse(message, {
                        text: "init",
                        start: range.start,
                        end: range.end,
                    });
                    createLabels({
                        text: "init",
                        start: range.start,
                        end: range.end,
                    });
                }
            );
        });
    });

    const changeDateRange = (newRange: rangeObject) => {
        loading = true;
        range = newRange;
        $statsStore.eventBus.send(
            "channel://aggregates/groupByOrgIdAndVideoId",
            {
                orgId: "4cd3f13b-604f-4ba8-baea-3c165d6b5bd3",
                from: range.start.unix(),
                to: range.end.unix(),
            },
            function (error, message) {
                loading = false;
                if (error) {
                    alert("Ups. Das sollte nicht passieren.");
                }
                fillBucketsWithDataResponse(message, range);
                createLabels(range);
            }
        );
    };
</script>

<div class="columns is-multiline is-variable is-8 wrapper">
    <div class="column is-12">
        <TimeSelectDropdown
            changeDateCallback={changeDateRange}
            changeSearchCallback={() => {}}
            searchDisabled
        />
    </div>
    <div class="column is-12">
        {#if loading}
            <div class="box">
                <span class="icon-text has-text-info" style="margin: auto;">
                    <span class="icon is-large">
                        <i
                            class="fas fa-spinner fa-pulse"
                            style="height: 1.5rem; width: 1.5rem;"
                        />
                    </span>
                    <span
                        style="margin: auto; padding-left: 10px; font-size: 1.25rem;"
                        >Loading ...</span
                    >
                </span>
            </div>
        {:else}
            <div class="columns is-multiline">
                <PlaysCounter
                    title="Video Plays"
                    amount={$statsStore.organisationStats.playouts}
                    decimals={0}
                />
                <PlaysCounter
                    title="Impressions"
                    amount={$statsStore.organisationStats.impressions}
                    decimals={0}
                />

                <PlaysCounter
                    title="Erwartete Einnahmen"
                    amount={$statsStore.organisationStats.turnover}
                    unit="€"
                />
            </div>
        {/if}
    </div>

    <div class="column is-half-desktop is-full-tablet">
        <PlaysTimeline
            id="impressions"
            {range}
            title="Impressions"
            labels={graphLabels}
            dataset={[
                {
                    label: "Verkauft",
                    data: $statsStore.organisationStats.timeRangeBuckets.map(
                        (bucket) => bucket.impressions
                    ),
                    backgroundColor: ["rgba(54, 162, 235, 0.2)"],
                    borderColor: ["rgba(54, 162, 235, 1)"],
                    borderWidth: 1,
                },
                // {
                //     label: "Ungenutzt",
                //     data: $statsStore.organisationStats.timeRangeBuckets.map(
                //         (bucket) => bucket.potentialImpressions
                //     ),
                //     backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                //     borderColor: ["rgba(255, 99, 132, 1)"],
                //     borderWidth: 1,
                // },
            ]}
        />
    </div>
    <div class="column is-half-desktop is-full-tablet">
        <PlaysTimeline
            id="turnover"
            {range}
            title="Einnahmen"
            labels={graphLabels}
            dataset={[
                {
                    label: "Erwirtschaftet",
                    data: $statsStore.organisationStats.timeRangeBuckets.map(
                        (bucket) => {
                            return bucket.turnover;
                        }
                    ),
                    backgroundColor: ["rgba(54, 162, 235, 0.2)"],
                    borderColor: ["rgba(54, 162, 235, 1)"],
                    borderWidth: 1,
                },
                // {
                //     label: "Potential",
                //     data: $statsStore.organisationStats.timeRangeBuckets.map(
                //         (bucket) => bucket.potentialTurnover
                //     ),
                //     backgroundColor: ["rgba(255, 99, 132, 0.2)"],
                //     borderColor: ["rgba(255, 99, 132, 1)"],
                //     borderWidth: 1,
                // },
            ]}
        />
    </div>
</div>

<style>
    .wrapper {
        padding-left: 2rem;
        padding-right: 2rem;
    }
</style>
